module.exports = __webpack_public_path__ + "static/media/add.6ee75122.svg";